import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type MarketSettingsSpiderSpiderDashboardController from 'lumen/controllers/market/settings/spider/spider-dashboard';
import type MarketSettingsIndexRoute from 'lumen/routes/market/settings/index';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import type { ModelFrom } from 'lumen/utils/routes';
import { PORTFOLIO_SETTINGS_PATHS } from 'lumen/utils/spider';

type Model = ModelFrom<MarketSettingsIndexRoute>;

type Params = {
  path: string;
};

@protectedRoute({ features: ['spider.settings.portfolio.edit'] })
export default class MarketSettingsSpiderSpiderDashboardRoute extends Route {
  @service declare router: Services['router'];

  dashboard: string | undefined = undefined;

  get extendedRouteName(): string {
    const { path } = this.paramsFor(
      'market.settings.spider.spider-dashboard',
    ) as {
      path: string;
    };

    return this.fullRouteName.replace('spider-dashboard', path);
  }

  beforeModel(): void {
    const { path } = this.paramsFor(
      'market.settings.spider.spider-dashboard',
    ) as {
      path: string;
    };

    if (!PORTFOLIO_SETTINGS_PATHS.includes(path)) {
      this.router.replaceWith(
        'market.settings.spider.spider-dashboard',
        PORTFOLIO_SETTINGS_PATHS[0],
      );
    }
  }

  model(params: Params): Model {
    /**
     * Stored `path` as a class property, because returning it from
     * the `model` hook will trigger a refresh when `path` changes.
     *
     * Spider handles changing routes. It will send a message to
     * update the URL.
     */
    this.dashboard = params.path;

    return this.modelFor('market.settings') as Model;
  }

  setupController(
    controller: MarketSettingsSpiderSpiderDashboardController,
  ): void {
    // @ts-expect-error: A spread argument must either have a tuple type or be passed to a rest parameter.
    // eslint-disable-next-line prefer-rest-params
    super.setupController(...arguments);

    controller.dashboard = this.dashboard;
  }
}
